function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignArrowLeftLine = function SvgAlignArrowLeftLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M8.703 16.95a1 1 0 0 0 0-1.415L6.167 13H15a1 1 0 1 0 0-2H6.167l2.536-2.536A1 1 0 0 0 7.288 7.05l-4.242 4.243a1 1 0 0 0 0 1.414l4.242 4.243a1 1 0 0 0 1.415 0ZM21 6a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V6Z"
  }));
};
export default SvgAlignArrowLeftLine;